import { jsx as _jsx } from "react/jsx-runtime";
import { trackError } from '@local/metrics';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/GridLegacy';
import { skipToken } from '@reduxjs/toolkit/query';
import { useContext } from 'react';
import { Navigate } from 'react-router';
import { useLoadLicenseOrgsQuery, useLoadLicenseTokenQuery, } from '../../apiClients/entitlementsClient/requests/EntitlementsAPI';
import { LOGIN_ERROR_ROUTE } from '../../constants';
import { getAvailableEvoInstances, getLastUsedHub, setCurrentEvoInstance, } from '../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { Background } from '../background/Background';
import { LoginContext } from '../loginHandler/LoginContext';
export function SkipOrgSelector({ homePagePath = '/' }) {
    var _a;
    const { service } = useContext(LoginContext);
    const { isLoading, error } = useLoadLicenseOrgsQuery(service !== 'none' ? { service } : skipToken);
    const availableEvoInstances = getAvailableEvoInstances();
    const haveLicence = !isLoading && !error && availableEvoInstances.length > 0;
    if (haveLicence) {
        setCurrentEvoInstance((_a = getLastUsedHub()) !== null && _a !== void 0 ? _a : availableEvoInstances[0]);
    }
    const token = useLoadLicenseTokenQuery(haveLicence ? { service } : skipToken);
    const err = error || token.error;
    if (err) {
        trackError('Token fetch failed', 'Error fetching license token in <SkipOrgSelector>', {
            discoverError: error,
            tokenError: token.error,
        });
        return _jsx(Navigate, { to: `${LOGIN_ERROR_ROUTE}?error=entitlements_failure` });
    }
    if (isLoading || token.isLoading) {
        return (_jsx(Background, { children: _jsx(Grid, { item: true, style: {
                    position: 'relative',
                    width: '100%',
                    height: '100px',
                }, alignContent: "center", justifyContent: "center", display: "grid", children: _jsx(CircularProgress, { "automation-id": "spinner-loading" }) }) }));
    }
    if (!haveLicence) {
        setCurrentEvoInstance({ hasNoLicense: true });
    }
    return _jsx(Navigate, { to: homePagePath });
}
//# sourceMappingURL=SkipOrgSelector.js.map